package com.starparty.app.astro0


import com.starparty.app.vector_maths.Point3d
import kotlin.math.PI

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class AltAzimuthCoords(var location: Location) : SphericalCoords() {

    fun setTime(t:SP_Time) {
        location.time = t
        makeRotation()
    }

    fun setLat(lat: Double) {
        location.place.latitude = lat
        makeRotation()
    }

    fun setLon(lon: Double) {
        location.place.longitude = lon
        makeRotation()
    }

    fun EquSphericalToAltAzmSpherical(ra: Double, dec: Double): SphPoint {
        val cart = Point3d()
        SphericalCoords.sphericalToCartesian(ra, dec, cart)
        val cartRot = invertRotateCartesian(cart)
        val altAzm = SphPoint()
        SphericalCoords.cartesianToSpherical(cartRot, altAzm)
        return altAzm
    }

    protected fun makeRotation() {
        val lst = location.localSiderealTime
//val ums = UMS.unitsToUMS(location.time.universalTime)
//        val jd = location.time.julianDate
//        val fromJD = location.time.fromJulian(jd.toLong())
//Log.d("julianDate", "${jd} $fromJD")
        val xRot = ((PI/2.0) - (location.place.latitude * MathD.DEG_TO_RAD))

        val lstRads = lst * MathD.DEG_TO_RAD

        // invert the z-axis
        itsRotation.setIdentity()
        itsRotation.m22 = -1.0
        itsRotIncMatrix.rotX(-xRot)
        itsRotation.mul(itsRotIncMatrix)
        itsRotIncMatrix.rotY(-lstRads)
        itsRotation.mul(itsRotIncMatrix)
        isInverseRotCurrent = false
    }

    init {
        makeRotation()
    }
}